/** Option D USA season-to-date PDF commodities (map download + mint allowlist).
 * Citrus family uses Fresh Cargo leaf `commodity` (mandarins/oranges/tangelos/clementines/…), not
 * category CITRUS; the aggregate basket is retired.
 */
export const IMPORTER_SEASON_COMMODITIES = Object.freeze([
  'blueberries',
  'grapes',
  'avocados',
  'mandarins',
  'oranges',
  'lemons',
  'limes',
  'grapefruits',
  'tangelos',
  'clementines',
]);

export const IMPORTER_SEASON_KIND = 'season_to_date';

/** Map filter aliases → Option D pack commodity key (Fresh Cargo leaf). */
const SEASON_COMMODITY_ALIASES = Object.freeze({
  blueberry: 'blueberries',
  blueberries: 'blueberries',
  grape: 'grapes',
  grapes: 'grapes',
  avocado: 'avocados',
  avocados: 'avocados',
  // USDA mobile / map leaves → Fresh Cargo commodity column
  tangerine: 'mandarins',
  tangerines: 'mandarins',
  mandarin: 'mandarins',
  mandarins: 'mandarins',
  orange: 'oranges',
  oranges: 'oranges',
  lemon: 'lemons',
  lemons: 'lemons',
  lime: 'limes',
  limes: 'limes',
  grapefruit: 'grapefruits',
  grapefruits: 'grapefruits',
  tangelo: 'tangelos',
  tangelos: 'tangelos',
  clementine: 'clementines',
  clementines: 'clementines',
  // Do NOT map "citrus" → basket: the aggregate is retired for Season Summary cards.
});

/** Normalize map commodity filter to season pack key, or '' if unsupported. */
export function resolveSeasonCommodity(raw) {
  const key = String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
  if (!key) return '';
  if (SEASON_COMMODITY_ALIASES[key]) return SEASON_COMMODITY_ALIASES[key];
  if (IMPORTER_SEASON_COMMODITIES.includes(key)) return key;
  return '';
}

/** True when a PDF probe response is OK and served as application/pdf. */
export function isPdfProbeOk(ok, contentType) {
  return Boolean(ok) && String(contentType || '').toLowerCase().includes('application/pdf');
}

/** Reduce a UI language tag (es-MX, ES_mx, …) to 'en' | 'es'; anything else is 'en'. */
export function normalizePdfLang(raw) {
  const primary = String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/_/g, '-')
    .split('-')[0];
  return primary === 'es' ? 'es' : 'en';
}

/** Season PDF file name; the English name is unchanged, Spanish adds `_es`. */
export function seasonPdfFilename(dest, crop, lang = 'en') {
  const suffix = normalizePdfLang(lang) === 'es' ? '_es' : '';
  return `${dest}_${crop}_season_to_date${suffix}.pdf`;
}

/** PDF language for the active i18n instance. */
export function pdfLangFromI18n(i18n) {
  return normalizePdfLang(i18n?.resolvedLanguage || i18n?.language);
}
